import { memo } from 'react';

import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

import { uiImages } from '@/react/components/content/registry/data';
import { RecommendationContext } from '@/configs/recommendations';
import { sliderSettings } from '../../registry/data/parts/sliderSettings';

/**
 * Register the ProductRecommendation component.
 */
const register = (): void => {
  Builder.registerComponent(memo(dynamic(async () => import('./index'))), {
    name: 'ProductRecommendations',
    friendlyName: 'DY Product Recommendations',
    inputs: [
      {
        name: 'context',
        type: 'string',
        friendlyName: 'Recommendation Context',
        enum: Object.entries(RecommendationContext).map(([key, value]) => {
          return { label: key, value };
        }),
        defaultValue: RecommendationContext.HomePage
      },
      sliderSettings
    ],
    image: uiImages.cubeImage
  });
};

export default register;
